module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQNJREFUeNq0lWENg0AMRg+y/yABCUhAAhKYg0lAwiScBCQggTlAwk1B15JuIwyOXu/2JS8QIHmjLV0GANYYUyN0HJHJ/CMoIib4ZkbuSMv3kvA+qRAH+xmQjp+JFhENnIfevEfqGBFxA3moxFZa4r2LFnQZ+IdWUlG5GQ5NJh6oT4mzxfabise8SDDYT6Tz1bWFNLFHpVvTp5BIRIabHCWRispYCZELmlkGNv+6NH8TiagOlNi9GylFh5L19vYxCnrSaVbQFucROOmuuwjKVni++Eb6R5kr+xMk0YqCJRqRSkI52t6foVydP1jiNCs8F75NlEQqipZIREkkZ6I5lYTyEmAAj/NapGVg6FwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/arrow3.png
// module id = KQDQ
// module chunks = 51